import React from 'react';
import { Switch } from '@nearst/ui';
import { Protect } from '@clerk/clerk-react';
import Tippy from '@tippyjs/react';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

import { useShop } from '@services/ShopProvider';
import AuthorizationTooltip from '@components/AuthorizationTooltip';
import { useCheckPermission } from '@services/auth/hooks';

import styles from './UnenrichedProductsToggle.module.scss';

const TOOLTIP_TEXT =
	'Products that only have a barcode (no title, description, or images) are hidden from your storefront and feed channels (Pinterest, TikTok, Snap). Google Local Listings is not affected — Google supplements its own product data. These products stay visible here so you can add titles.';

export const UnenrichedProductsToggle = () => {
	const { shop, updateShop } = useShop();
	const authorized = useCheckPermission('org:inventory:edit');

	// Default ON — only an explicit `false` opts out
	const hiding = shop.hideUnenrichedProducts !== false;

	const onChange = async (e) => {
		await updateShop(shop.id, { hideUnenrichedProducts: e.target.checked });
	};

	return (
		<Protect permission="org:inventory:edit" fallback={null}>
			<AuthorizationTooltip authorized={authorized}>
				<label className={styles.toggle}>
					<Switch checked={hiding} onChange={onChange} disabled={!authorized} />
					<span>Hide products without titles</span>
				</label>
			</AuthorizationTooltip>
			<Tippy content={TOOLTIP_TEXT} placement="bottom" className={styles.tooltip}>
				<InformationCircleIcon className={styles.infoIcon} />
			</Tippy>
		</Protect>
	);
};
